import { TutorForm } from '@/features/tutors/components/tutor-form'
import { createFileRoute } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { tutorService } from '@/services/tutorService'
import { fakeData } from '@/features/tutors/data/fake-data'
import type { UserResponse } from '@/types/user'

export const Route = createFileRoute('/_authenticated/tutors/edit/$tutorId')({
  component: EditTutor,
})

function EditTutor() {
  const { tutorId } = Route.useParams()

  const initialTutor = fakeData.tutors.find((tutor) => tutor.id === tutorId)

  const { data, isLoading, error } = useQuery<UserResponse>({
    queryKey: ['tutor', tutorId],
    queryFn: () => tutorService.getTutorById(tutorId),
    initialData: initialTutor
      ? {
          status: true,
          message: 'initial',
          data: initialTutor,
        }
      : undefined,
  })

  if (isLoading) {
    return <div className="p-4">Loading...</div>
  }

  if (error) {
    return <div className="p-4 text-red-600">Error loading tutor.</div>
  }

  const tutor = data?.data ?? null
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Edit Tutor</h1>
      <TutorForm tutor={tutor} />
    </div>
  )
}
